import React from 'react';
import ReactDOM from 'react-dom';
import Youtube from 'components/application/Youtube';

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.youtube');
  Array.prototype.forEach.call(elements, (el, i) => { // hack for old browsers
    ReactDOM.render(React.createElement(Youtube, {
      videoEmbedURL: el.getAttribute('data-url'),
      alt:           el.getAttribute('data-alt')
    }), el);
  });
});



// WEBPACK FOOTER //
// ./app/javascript/packs/youtube.js